import React from "react";

export default function Lightbulb(props) {
  return (
    <svg
      width={13}
      height={20}
      viewBox="0 0 13 20"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M9.393 10.034c-.626.457-1.217.89-1.408 1.592l-.039.14c-.277 1.018-.361 1.302-.791 1.382H5.781c-.405-.078-.48-.349-.714-1.305l-.05-.204c-.179-.72-.779-1.162-1.415-1.63C2.635 9.297 1.54 8.489 1.54 6.5A4.966 4.966 0 0 1 6.5 1.54a4.966 4.966 0 0 1 4.96 4.96c0 2.024-1.05 2.792-2.067 3.534zm-1.29 7.412c0 .14-.114.255-.254.255H5.07a.255.255 0 0 1-.254-.255v-.213c0-.14.115-.255.254-.255H7.85c.14 0 .254.115.254.255v.213zM6.46 14.723c.29 0 .544-.011.771-.035h.618c.14 0 .254.114.254.255v.213c0 .14-.114.255-.254.255H5.07a.255.255 0 0 1-.254-.255v-.213c0-.14.115-.255.254-.255h.65c.219.024.463.035.739.035zM6.5 0A6.507 6.507 0 0 0 0 6.5c0 2.768 1.618 3.96 2.688 4.748.352.259.79.581.834.761l.05.201c.13.533.247.97.402 1.323-.42.33-.697.836-.697 1.41v.213c0 .388.127.744.337 1.039-.21.294-.337.65-.337 1.038v.213c0 .99.805 1.794 1.794 1.794H7.85c.99 0 1.794-.804 1.794-1.794v-.213a1.78 1.78 0 0 0-.337-1.038c.21-.295.337-.651.337-1.04v-.212c0-.56-.264-1.056-.669-1.386.168-.36.302-.814.458-1.387l.038-.139c.05-.183.465-.486.832-.753C11.376 10.492 13 9.306 13 6.5 13 2.916 10.084 0 6.5 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
